import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Dialog from '../../components/dialog.jsx';

function PodcastSelect() {
    const navigate = useNavigate();
    const [podcasts, setPodcasts] = useState([]);
    const [speakers, setSpeakers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [_speakerSearch, setSpeakerSearch] = useState('');
    const podcastListRef = useRef(null);
    const speakerListRef = useRef(null);

    const containerStyle = {
        flexGrow: 0,
        maxHeight: '70vh',
        overflowY: 'auto',
        fontFamily: 'system-ui, -apple-system, sans-serif'
    };

    const itemStyle = {
        display: 'block',
        padding: '12px 16px',
        marginBottom: '8px',
        borderRadius: '8px',
        textDecoration: 'none',
        color: '#334155',
        fontWeight: '500',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        border: '1px solid transparent',
        backgroundColor: '#f8fafc' // Subtle off-white
    };

    const emptyStateStyle = {
        padding: '40px 20px',
        color: '#64748b',
        textAlign: 'center',
        border: '2px dashed #e2e8f0',
        borderRadius: '12px',
        fontSize: '0.95rem'
    };

    /*useEffect(() => {
        axios.post(process.env.REACT_APP_API_URL + 'podcasts').then(r => {
            if (r?.data?.status === 'Success') {
                setPodcasts(r.data.results);
            }
        });
    }, []);*/

    const podcastSearch = () => {
        if (loading)
            return;
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'podcasts', {
            search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setPodcasts(r.data.results);
                podcastListRef.current.show();
            }
        });
    }
    const speakerSearch = () => {
        if (loading)
            return;
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'host', {
            search: _speakerSearch,
            page: 0
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setSpeakers(r.data.results);
                speakerListRef.current.show();
            }
        });
    }

    const podcastSelect = (podcastId) => {
        if (loading)
            return;
        var err = [];
        if (podcastId === 0)
            err.push('Please select a podcast.');
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'podcast/switch', {
                id: podcastId
            }).then((r) => {
                setLoading(false);
                if (r?.data?.token) {
                    localStorage.setItem('jwt', r.data.token);
                    navigate('/');
                }
            }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }
    const speakerSelect = (speakerId) => {
        if (loading)
            return;
        var err = [];
        if (speakerId === 0)
            err.push('Please select a speaker.');
        if (err.length === 0) {
            setLoading(true);
            axios.post(process.env.REACT_APP_API_URL + 'speaker/switch', {
                id: speakerId
            }).then((r) => {
                setLoading(false);
                if (r?.data?.token) {
                    localStorage.setItem('jwt', r.data.token);
                    navigate('/');
                }
            }).catch(e => setLoading(false));
        } else {
            let t_id = toast.error(<div>{err.map(e => <div>{e}</div>)}</div>);
            setTimeout(() => toast.dismiss(t_id), 2000)
        }
    }

    return (
        <div className="container-center">
            <Dialog ref={podcastListRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        podcastListRef.current.hide();
                    }}>Close</button>
                </div>
            )}>
                <div style={containerStyle} className="flex f-col f-start">
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#1e293b' }}>
                        Podcasts
                    </h2>

                    {podcasts.length === 0 ? (
                        <div style={emptyStateStyle}>
                        <p style={{ margin: 0 }}>No podcasts available yet.</p>
                        </div>
                    ) : (
                        podcasts.map((p, i) => (
                        <a
                            key={p.id || i}
                            role="button"
                            style={itemStyle}
                            onClick={() => podcastSelect(p.id)}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#eff6ff';
                                e.currentTarget.style.borderColor = '#3b82f6';
                                e.currentTarget.style.color = '#1d4ed8';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                e.currentTarget.style.borderColor = 'transparent';
                                e.currentTarget.style.color = '#334155';
                            }}
                        >
                            {p.name}
                        </a>
                        ))
                    )}
                </div>
            </Dialog>
            <Dialog ref={speakerListRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        speakerListRef.current.hide();
                    }}>Close</button>
                </div>
            )}>
                <div style={containerStyle} className="flex f-col f-start">
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#1e293b' }}>
                        Hosts/Guests
                    </h2>

                    {speakers.length === 0 ? (
                        <div style={emptyStateStyle}>
                        <p style={{ margin: 0 }}>No hosts/guests available yet.</p>
                        </div>
                    ) : (
                        speakers.map((p, i) => (
                        <a
                            key={p.id || i}
                            role="button"
                            style={itemStyle}
                            onClick={() => speakerSelect(p.id)}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#eff6ff';
                                e.currentTarget.style.borderColor = '#3b82f6';
                                e.currentTarget.style.color = '#1d4ed8';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                e.currentTarget.style.borderColor = 'transparent';
                                e.currentTarget.style.color = '#334155';
                            }}
                        >
                            {p.firstName} {p.lastName}
                        </a>
                        ))
                    )}
                </div>
            </Dialog>
            <div className="container mw-800 w-100 p-10">
                <div className="form a-end">
                    <div className="w-60 xs-w-100">
                        <label htmlFor="search">Search Podcasts</label>
                        <input type="text" id="search" className="w-100" value={search} onChange={(e) => { setSearch(e.target.value) }} />
                    </div>
                    <div className="w-20 xs-w-50">
                        <button className="btn" onClick={podcastSearch}>
                            {loading ? (
                                <div className="loading f-row">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            ) : <>Search</>
                            }
                        </button>
                    </div>
                    <div className="w-20 xs-w-50">
                        <Link className="btn" to="/protected/podcast-create">
                            Create Podcast
                        </Link>
                    </div>
                </div>
            </div>
            <div className="container mw-800 w-100 p-10 mt-20">
                <div className="form a-end">
                    <div className="w-80 xs-w-100">
                        <label htmlFor="search">Search Hosts/Guests</label>
                        <input type="text" id="search" className="w-100" value={_speakerSearch} onChange={(e) => { setSpeakerSearch(e.target.value) }} />
                    </div>
                    <div className="w-20 xs-w-50">
                        <button className="btn" onClick={speakerSearch}>
                            {loading ? (
                                <div className="loading f-row">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            ) : <>Search</>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PodcastSelect;